export default __webpack_public_path__ + "static/media/recovered.b9b05772.svg";